/** The real link: a dedicated module worker under the Trusted Types policy (BENCH-V2-SPEC §12.4, UD-9). */
import type { FromBench, ToBench } from '../../shared/bench-protocol.ts';
import benchUrl from '../../worker/bench.ts?worker&url';
import { spawnWorker } from '../trusted-worker.ts';
import { BenchClient, type BenchLink } from './bench-client.ts';

export function createWorkerLink(): BenchLink {
	const w = spawnWorker(benchUrl, 'provenance-bench');
	const handlers = new Set<(m: FromBench) => void>();
	w.onmessage = (e: MessageEvent<FromBench>) => {
		for (const h of handlers) h(e.data);
	};
	let crash: (() => void) | null = null;
	w.onerror = (e) => {
		e.preventDefault();
		crash?.();
	};
	w.onmessageerror = () => crash?.();
	return {
		onCrash: (cb) => {
			crash = cb;
		},
		post: (m: ToBench) => w.postMessage(m),
		subscribe: (h) => {
			handlers.add(h);
			return () => handlers.delete(h);
		},
		terminate: () => w.terminate(),
	};
}

export const createBenchClient = (): BenchClient => new BenchClient(createWorkerLink);
